import { useGlobalStateSelector, words } from './globalState';
import { TextLine3 } from './UtilComponents';
import iconFilter from './image/filter_alt_24dp_FILL0_wght400_GRAD0_opsz24.svg';

// TOKEN FILTER SECTION
function TokenFilterSection(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayerNext = props.popupLayerNext;


  return (
    <button className='button2'
      onClick={ () => {
        const popup = { type: 'tokenFilterPopup' };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      { words.filter[state.language] }
    </button>
  );
}

// TOKEN FILTER POPUP
function TokenFilterPopup(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;


  return (
    <div className='flexColumn alignItemsCenter'>
      <div className='flexRow justifyContentCenter ' >
        {
          state.tokenFilter.conditions.map( (condition, index) => {
            let styleFocused;

            if (index === state.tokenFilter.conditionIndex) {
              styleFocused = ' backgroundColorPinkPale';
            }
            else {
              styleFocused = ' backgroundColorTransparent';
            }

            return (
              <button className={'flexColumn alignItemsFlexEnd widthMin5 heightMin5 margin0p5 borderMonacotto ' + styleFocused}
                onClick={ () => {
                  dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditionIndex'], value: index });
                }}
              >
                <button className='backgroundColorTransparent borderNone '
                  onClick={ (event) => {
                    if (state.tokenFilter.conditions.length >= 2) {
                      const conditions = [ ...state.tokenFilter.conditions];
                      conditions.splice(index, 1);

                      dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions'], value: conditions});

                      if (state.tokenFilter.conditionIndex === state.tokenFilter.conditions.length - 1) {
                        dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditionIndex'], value: state.tokenFilter.conditions.length - 2 });
                      }
                    }
                    else {
                      const conditionsInitial = [
                        {
                          assetCommon: [],
                          addressOwners: [],
                          lockStatus: [],
                          monacardName: [],
                          monacardIssuerNames: [],
                          monacardDescription: [],
                          monacardTags: [],
                          monadom: [],
                        },
                      ];

                      dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions'], value: conditionsInitial });
                      dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditionIndex'], value: 0 });
                    }

                    event.stopPropagation();
                  }}
                >
                  <div className='font2 ' >
                    ×
                  </div>
                </button>
                <div className='flexColumn alignItemsCenter ' >
                  <ConditionSection condition={condition} popupLayer={popupLayer} conditionKey='assetCommon' />
                  <ConditionSection condition={condition} popupLayer={popupLayer} conditionKey='addressOwners' />
                  <ConditionSection condition={condition} popupLayer={popupLayer} conditionKey='lockStatus' />
                  <ConditionSection condition={condition} popupLayer={popupLayer} conditionKey='monacardName' />
                  <ConditionSection condition={condition} popupLayer={popupLayer} conditionKey='monacardIssuerNames' />
                  <ConditionSection condition={condition} popupLayer={popupLayer} conditionKey='monacardDescription' />
                  <ConditionSection condition={condition} popupLayer={popupLayer} conditionKey='monacardTags' />
                  <ConditionSection condition={condition} popupLayer={popupLayer} conditionKey='monadom' />
                </div>
              </button>
            );
          })
        }
      </div>
      <div className='flexRow justifyContentFlexStart' >
        <TextLine3 fieldName='tokenFilterAddressOwner' keys={['tokenFilter', 'assetCommon']} face={`${words.assetCommon[state.language]} (${words.partialMatch[state.language]})`} tooltip='true' />
        <button className='button1' tabindex='0'
          onClick={ () => {
            let assetCommons;

            if (state.tokenFilter.assetCommon !== undefined && state.tokenFilter.assetCommon !== null && state.tokenFilter.assetCommon !== '') {
              assetCommons = [ ...state.tokenFilter.conditions[state.tokenFilter.conditionIndex].assetCommon, state.tokenFilter.assetCommon ];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditionIndex, 'assetCommon'], value: assetCommons });
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'assetCommon'], value: '' });
            }
          }}
        >
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      </div>
      <div className='flexRow justifyContentFlexStart' >
        <TextLine3 fieldName='tokenFilterAddressOwner' keys={['tokenFilter', 'addressOwner']} face={words.addressOwner[state.language]} tooltip='true' />
        <button className='button1' tabindex='0'
          onClick={ () => {
            let addressOwners;

            if (state.tokenFilter.addressOwner !== undefined && state.tokenFilter.addressOwner !== null && state.tokenFilter.addressOwner !== '') {
              addressOwners = [ ...state.tokenFilter.conditions[state.tokenFilter.conditionIndex].addressOwners, state.tokenFilter.addressOwner ];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditionIndex, 'addressOwners'], value: addressOwners });
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'addressOwner'], value: '' });
            }
          }}
        >
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      </div>
      <div className='flexRow justifyContentFlexStart' >
        <div className='flexRow justifyContentCenter box1Width ' >
          <button className={'box3 focusEffect01 riseOut2 ' + (state.tokenFilter.lockStatus === 'locked' ? 'colorRed borderSelected' : 'borderNone')}
            tabindex='0'
            onClick={ () => {
              dispatch({type: 'setStateMultiLayers', keys: ['tokenFilter', 'lockStatus'], value: 'locked'});
            }}
          >
            <div>
              {words.locked[state.language]}
            </div>
          </button>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.tokenFilter.lockStatus === 'unlocked' ? 'colorRed borderSelected' : 'borderNone')}
            tabindex='0'
            onClick={ () => {
              dispatch({type: 'setStateMultiLayers', keys: ['tokenFilter', 'lockStatus'], value: 'unlocked'});
            }}
          >
            <div>
              {words.unlocked[state.language]}
            </div>
          </button>
        </div>
        <button className='button1' tabindex='0'
          onClick={ () => {
            let lockStatuses;

            if (state.tokenFilter.lockStatus !== undefined && state.tokenFilter.lockStatus !== null && state.tokenFilter.lockStatus !== '') {
              lockStatuses = [state.tokenFilter.lockStatus];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditionIndex, 'lockStatus'], value: lockStatuses });
            }
          }}
        >
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      </div>
      <div className='flexRow justifyContentFlexStart' >
        <TextLine3 fieldName='tokenFilterMonacardName' keys={['tokenFilter', 'monacardName']} face={`${words.monacardName[state.language]} (${words.partialMatch[state.language]})`} tooltip='true' />
        <button className='button1' tabindex='0'
          onClick={ () => {
            let monacardNames;

            if (state.tokenFilter.monacardName !== undefined && state.tokenFilter.monacardName !== null && state.tokenFilter.monacardName !== '') {
              monacardNames = [ ...state.tokenFilter.conditions[state.tokenFilter.conditionIndex].monacardName, state.tokenFilter.monacardName ];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditionIndex, 'monacardName'], value: monacardNames });
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'monacardName'], value: '' });
            }
          }}
        >
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      </div>
      <div className='flexRow justifyContentFlexStart' >
        <TextLine3 fieldName='tokenFilterMonacardIssuerName' keys={['tokenFilter', 'monacardIssuerName']} face={words.issuerName[state.language]} tooltip='true' />
        <button className='button1' tabindex='0'
          onClick={ () => {
            let monacardIssuerNames;

            if (state.tokenFilter.monacardIssuerName !== undefined && state.tokenFilter.monacardIssuerName !== null && state.tokenFilter.monacardIssuerName !== '') {
              monacardIssuerNames = [ ...state.tokenFilter.conditions[state.tokenFilter.conditionIndex].monacardIssuerNames, state.tokenFilter.monacardIssuerName ];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditionIndex, 'monacardIssuerNames'], value: monacardIssuerNames });
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'monacardIssuerName'], value: '' });
            }
          }}
        >
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      </div>
      <div className='flexRow justifyContentFlexStart' >
        <TextLine3 fieldName='tokenFilterMonacardDescription' keys={['tokenFilter', 'monacardDescription']} face={`${words.monacardDescription[state.language]} (${words.partialMatch[state.language]})`} tooltip='true' />
        <button className='button1' tabindex='0'
          onClick={ () => {
            let monacardDescriptions;

            if (state.tokenFilter.monacardDescription !== undefined && state.tokenFilter.monacardDescription !== null && state.tokenFilter.monacardDescription !== '') {
              monacardDescriptions = [ ...state.tokenFilter.conditions[state.tokenFilter.conditionIndex].monacardDescription, state.tokenFilter.monacardDescription ];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditionIndex, 'monacardDescription'], value: monacardDescriptions });
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'monacardDescription'], value: '' });
            }
          }}
        >
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      </div>
      <div className='flexRow justifyContentFlexStart' >
        <TextLine3 fieldName='tokenFilterMonacardTag' keys={['tokenFilter', 'monacardTag']} face={words.monacardTag[state.language]} tooltip='true' />
        <button className='button1' tabindex='0'
          onClick={ () => {
            let monacardTags;

            if (state.tokenFilter.monacardTag !== undefined && state.tokenFilter.monacardTag !== null && state.tokenFilter.monacardTag !== '') {
              monacardTags = [ ...state.tokenFilter.conditions[state.tokenFilter.conditionIndex].monacardTags, state.tokenFilter.monacardTag ];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditionIndex, 'monacardTags'], value: monacardTags });
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'monacardTag'], value: '' });
            }
          }}
        >
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      </div>
      <div className='widthMax textLeft marginTop0p5' >
        { words.monadomRegistration[state.language] }
      </div>
      <div className='flexRow justifyContentFlexStart' >
        <div className='flexRow justifyContentCenter box1Width ' >
          <button className={'box3 focusEffect01 riseOut2 ' + (state.tokenFilter.monadom === 'registered' ? 'colorRed borderSelected' : 'borderNone')}
            tabindex='0'
            onClick={ () => {
              dispatch({type: 'setStateMultiLayers', keys: ['tokenFilter', 'monadom'], value: 'registered'});
            }}
          >
            <div>
              {words.registered[state.language]}
            </div>
          </button>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.tokenFilter.monadom === 'unregistered' ? 'colorRed borderSelected' : 'borderNone')}
            tabindex='0'
            onClick={ () => {
              dispatch({type: 'setStateMultiLayers', keys: ['tokenFilter', 'monadom'], value: 'unregistered'});
            }}
          >
            <div>
              {words.unregistered[state.language]}
            </div>
          </button>
        </div>
        <button className='button1' tabindex='0'
          onClick={ () => {
            let monadoms;

            if (state.tokenFilter.monadom !== undefined && state.tokenFilter.monadom !== null && state.tokenFilter.monadom !== '') {
              monadoms = [state.tokenFilter.monadom];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditionIndex, 'monadom'], value: monadoms });
            }
          }}
        >
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      </div>
      {/*
        <button className='button3 flexRow justifyContentCenter alignItemsCenter'
          onClick={ () => {
            let addressOwners;

            if (state.tokenFilter.addressOwner !== undefined && state.tokenFilter.addressOwner !== null && state.tokenFilter.addressOwner !== '') {
              addressOwners = [ ...state.tokenFilter.conditions.addressOwners, state.tokenFilter.addressOwner ];
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', 'addressOwners'], value: addressOwners });
              dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'addressOwner'], value: '' });
            }
          }}
        >
          <div>
            {words.filter[state.language]}
          </div>
          <img className='size2x2' src={iconFilter} alt='' />
        </button>
      */}
      <div className='flexRow justifyContentFlexStart' >
        <button className='button3 flexRow justifyContentCenter alignItemsCenter'
          onClick={ () => {
            const conditionsInitial = {
              assetCommon: [],
              addressOwners: [],
              lockStatus: [],
              monacardName: [],
              monacardIssuerNames: [],
              monacardDescription: [],
              monacardTags: [],
              monadom: [],
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions', state.tokenFilter.conditions.length], value: conditionsInitial });
            dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditionIndex'], value: state.tokenFilter.conditions.length });
          }}
        >
          {words.addAndCondition[state.language]}
        </button>
        <button className='button3 flexRow justifyContentCenter alignItemsCenter'
          onClick={ () => {
            const conditionsInitial = [
              {
                assetCommon: [],
                addressOwners: [],
                lockStatus: [],
                monacardName: [],
                monacardIssuerNames: [],
                monacardDescription: [],
                monacardTags: [],
                monadom: [],
              },
            ];

            dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditions'], value: conditionsInitial });
            dispatch({ type: 'setStateMultiLayers', keys: ['tokenFilter', 'conditionIndex'], value: 0 });
          }}
        >
          {words.clear[state.language]}
        </button>
      </div>
    </div>
  );
}

// CONDITION SECTION
function ConditionSection(props) {
  const { state } = useGlobalStateSelector(({ state }) => ({ state }));
  const popupLayer = props.popupLayer;
  const condition = props.condition;
  const conditionKey = props.conditionKey;

  if (condition[conditionKey].length <= 0) {
    return null;
  }

  return (
    <div className='flexColumn alignItemsCenter borderMonacottoPale margin0p5'>
      <div className='flexColumn margin0p5 ' >
        { words[conditionKey][state.language] }
      </div>
      {
        condition[conditionKey].map( value =>
          <ValueForDisplayInList popupLayer={popupLayer} conditionKey={conditionKey} value={value} />
        )
      }
    </div>
  );
}

// VALUE FOR DISPLAY IN LIST
function ValueForDisplayInList(props) {
  const { dispatch } = useGlobalStateSelector(({ dispatch }) => ({ dispatch }));
  const popupLayer = props.popupLayer;
  const conditionKey = props.conditionKey;
  const value = props.value;

  if (conditionKey === 'addressOwners') {
    return (
      <button className='backgroundColorMonacottoPale borderNone margin0p5 '
        onClick={ () => {
          const body = value;
          const popup = { type: 'generalItems', body: body };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
        }}
      >
        { value.substring(value.length - 6) }
      </button>
    );
  }
  else {
    return (
      <button className='backgroundColorMonacottoPale borderNone margin0p5 ' >
        { value }
      </button>
    );
  }
}

// SORT BY TOKEN NAME
function sortByTokenName(state, assets) {
  // トークン名でソート

  return assets.sort( (a, b) => {
    let aComp;
    let bComp;

    if (state.assetInfo[a.asset]?.asset_longname !== undefined && state.assetInfo[a.asset]?.asset_longname !== null) {
      aComp = state.assetInfo[a.asset].asset_longname; 
    }
    else {
      aComp = a.asset; 
    }

    if (state.assetInfo[b.asset]?.asset_longname !== undefined && state.assetInfo[b.asset]?.asset_longname !== null) {
      bComp = state.assetInfo[b.asset].asset_longname; 
    }
    else {
      bComp = b.asset; 
    }

    if (aComp < bComp) {
      return -1;
    }
    else if (aComp > bComp) {
      return 1;
    }
    else {
      return 0;
    }
  });
}

export {
  TokenFilterSection,
  TokenFilterPopup,
  sortByTokenName,
};
